<div id="unauthorized-page-container">
    <div id="text-container">
        <h1 class="title">Serving research. Saving confidential data.</h1>

        <div class="content">
            <p>We can automate genotyping, but not page permissions.</p>
            <p class="small-width">
                if you feel like you have reached this in error,<br />
                contact our Genetic Services team will be happy to assist you at <br />
                <a href="mailto: help@transnetyx.com" class="link">{{ 'help@transnetyx.com' }}</a> or call
                <a href="tel: 888-321-2113" class="link">888-321-2113</a>.
            </p>
        </div>

        <div class="action-buttons">
            <btn [id]="'error-page-sign-out-btn'" [label]="'Sign Out'" (onClick)="logout()"></btn>
            <btn
                [id]="'go-to-dashboard-btn'"
                [icon]="'fa-regular fa-comments'"
                [label]="'Go to Dashboard'"
                (onClick)="goToDashboard()"></btn>
        </div>
    </div>

    <div id="image-container">
        <img src="images/error_403.svg" alt="server-error-image" />
    </div>
</div>
